import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GalleryCard } from '../../../../components/gallery/LibraryGalleryCard';
import { GalleryViewMode } from '../../../../components/gallery/types';
import { LibraryWorkoutTemplate } from '../types';

export const WorkoutTemplateCard = ({
  item,
  viewMode,
  onClick,
}: {
  item: LibraryWorkoutTemplate;
  viewMode: GalleryViewMode;
  onClick: (item: LibraryWorkoutTemplate) => void;
}) => {
  const { t } = useTranslation();
  const { name } = item;
  const workoutCount = item.template.length;
  return (
    <GalleryCard title={name} viewMode={viewMode} onClick={() => onClick(item)}>
      {workoutCount > 1 && (
        <Chip size="small" label={t('workoutCount', { count: workoutCount })} />
      )}
    </GalleryCard>
  );
};
